// extracted by mini-css-extract-plugin
export default {"zoomModal":"J4-z"};